module.exports = __webpack_public_path__ + "organization.005d0550eb91c5e0d54c73ceca7764ff.svg";